import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import OutlinedText from "components/Input/OutlinedText/OutlinedText";
import Selection from "components/Input/Selection/Selection";
import statusOptions from "utils/statusOptions/StatusOptions.jsx";
import s from "./ChangeContent.module.scss";

const ChangeContent = ({ handleInput, data }) => {
  const { t } = useTranslation();
  const [inputData, setInputData] = useState({
    status: "",
  });
  const [focus, setFocus] = useState({});

  const textInputOnchange = (e, field, callback) => {
    let { value } = e.target;
    if (callback) {
      value = callback(value);
    }
    handleInput(value, field);
  };
  const textInputOnFocus = (field) => {
    setFocus({ [field]: true });
  };
  const textInputOnBlur = (field) => {
    setFocus({ [field]: false });
  };

  const statusOnChange = (value) => {
    setInputData({ ...inputData, status: value });
    return value;
  };

  return (
    <div className={s.contentContainer}>
      <div>
        <OutlinedText
          label={t(
            "page.analytics.sales.performance.change.function.dialog.content.1",
          )}
          mandatory
          noErrorMessage
          defaultValue={data.firstName ? data.firstName : ""}
          onchangeFn={(e) => textInputOnchange(e, "firstName")}
          onfocusFn={() => textInputOnFocus("firstName")}
          onblurFn={() => textInputOnBlur("firstName")}
          sxParams={{ textFocus: focus.firstName }}
        />
      </div>

      <div>
        <OutlinedText
          label={t(
            "page.analytics.sales.performance.change.function.dialog.content.2",
          )}
          mandatory
          noErrorMessage
          defaultValue={data.lastName ? data.lastName : ""}
          onchangeFn={(e) => textInputOnchange(e, "lastName")}
          onfocusFn={() => textInputOnFocus("lastName")}
          onblurFn={() => textInputOnBlur("lastName")}
          sxParams={{ textFocus: focus.lastName }}
        />
      </div>

      <div>
        <OutlinedText
          label={t("page.analytics.sales.performance.change.function.dialog.content.3" )}
          noErrorMessage
          defaultValue={data.email ? data.email : ""}
          onchangeFn={(e) => textInputOnchange(e, "email")}
          onfocusFn={() => textInputOnFocus("email")}
          onblurFn={() => textInputOnBlur("email")}
          sxParams={{ textFocus: focus.email }}
        />
      </div>

      <div>
        <Selection
          label={t("page.analytics.sales.performance.change.function.dialog.content.4")}
          mandatory
          selectionValue={
            inputData.status ? inputData.status : data.status ? data.status : ""
          }
          noErrorMessage
          onchangeFn={(e) => textInputOnchange(e, "status", statusOnChange)}
          onfocusFn={() => textInputOnFocus("status")}
          onblurFn={() => textInputOnBlur("status")}
          options={statusOptions(["ACTIVE", "SUSPENDED"])}
          sxParams={{ selectionFocus: focus.status }}
        />
      </div>
    </div>
  );
};

export default React.memo(ChangeContent);
